import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EulaService {
  constructor(private httpService: HttpService) {}

  getEula(): Observable<any> {
    return this.httpService.get('eula');
  }

  createOrUpdateEula(payload: any): Observable<any> {
    return this.httpService.post(`eula`, payload);
  }
}